import copy from 'copy-to-clipboard';

$('.btn.copy').on('click', () => {
  const text = $('textarea').val().trim();
  if (text === '') return;
  const success = copy(text);
  $('.btn.copy .icon.copy').hide();
  $('.btn.copy .icon.spinner').show();
  setTimeout(() => {
    $('.btn.copy .icon.spinner').hide();
    if (success) $('.btn.copy .icon.ok').show();
    else $('.btn.copy .icon.error').show();
    setTimeout(() => {
      if (success) $('.btn.copy .icon.ok').hide();
      else $('.btn.copy .icon.error').hide();
      $('.btn.copy .icon.copy').show();
    }, 750);
  }, 1000);
});

$('.btn.undo').on('click', () => {});
$('.btn.redo').on('click', () => {});
$('.btn.clear').on('click', () => {
  $('textarea').val('');
});
$('.btn.download').on('click', () => {
  const text = $('textarea').val().trim();
  if (text === '') return;
  const blob = new Blob([text], { type: 'plain/text' });
  const url = URL.createObjectURL(blob);
  const $anchor = $('<a></a>')
    .attr('href', url)
    .attr('download', 'content.txt')
    .hide();
  $('body').append($anchor);
  $anchor.get(0).click();
  $('body').remove($anchor);
});
